import { BANNER_DATA } from "@constants/banner";
import { useRouter } from "next/router";
// import useLedgerLive from "./useLedgerLive";

const useBanner = () => {
  const router = useRouter();
  const { pathname } = router;
  // const { isLedgerConnected } = useLedgerLive();

  const showBanner = BANNER_DATA.text && BANNER_DATA.pages.includes(pathname);
  //&& isLedgerConnected;

  return { showBanner };
};

export default useBanner;
